import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "../header"
import "../layout.css"
import Navbar from "./navbar"
import styled from "styled-components"
import { constants } from "../../constants/constants"
import { colors } from "../../style/colors"
import MediaQuery from "react-responsive"
import { AnimatePresence } from "framer-motion"
import { useRecoilState, useRecoilValue } from "recoil"
import { showingContact } from "../../state/atoms"
import ContactPopup from "../contact/contact-popup"
import MobileNavbar from "./mobile-navbar"

const Content = styled.main`
  margin-left: ${constants.navWidth};
  @media (max-width: 500px) {
    margin: 0;
  }
`
const BrandBar = styled.section`
  background: ${colors.accent};
  width: 100vw;
  margin: 0 auto;
  height: 5px;
  width: 100vw;
  position: absolute;
  z-index: 101;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
`

const ProjectsLayout = ({ children, activeCategory, brand }) => {

  const [showContact, setShowContact] = useRecoilState(showingContact)

  const data = useStaticQuery(graphql`
    query MyQuery {
      categories: allWordpressCategory(
        filter: { name: { ne: "Team" } }
      ) {
        edges {
          node {
            name
          }
        }
      }
      projects: allWordpressPost {
        edges {
          node {
            categories {
              name
              slug
            }
            slug
            title
          }
        }
      }
    }
  `)

  return (
    <>
      <AnimatePresence>
        {showContact && <ContactPopup /> }
      </AnimatePresence>
      <MediaQuery maxDeviceWidth={650}>
        <MobileNavbar
          activeSlug={activeCategory}
          categories={data.categories.edges}
          projects={data.projects.edges}
          setShowContact={setShowContact}
        />
      </MediaQuery>
      <MediaQuery minDeviceWidth={650}>
        <Navbar
          activeSlug={activeCategory}
          categories={data.categories.edges}
          projects={data.projects.edges}
        />
        <Header />
      </MediaQuery>
      <Content>{children}</Content>
      {brand && <BrandBar />}
    </>
  )
}

ProjectsLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ProjectsLayout